module.exports = __webpack_public_path__ + "img/activ8.3cfb0871.png";